
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 1.25a.75.75 0 00-.696.471l-2 5A.75.75 0 002.25 7v6c0 .414.336.75.75.75h1.354a2.751 2.751 0 005.292 0h4.707a2.751 2.751 0 005.293 0H21a.75.75 0 00.75-.75V9A2.75 2.75 0 0019 6.25h-.64l-3.774-4.719A.75.75 0 0014 1.25H5zm14.646 11h.604V9A1.25 1.25 0 0019 7.75H3.75v4.5h.604a2.751 2.751 0 015.292 0h4.707a2.751 2.751 0 015.293 0zM15.75 13a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0zm-7.5 0a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0zM4.108 6.25l1.4-3.5h5.742v3.5H4.108zm9.532-3.5l2.8 3.5h-3.69v-3.5h.89z","fill":"#fff"}})])
          )
        }
      }
    